import axios from 'axios';
import {BACKEND_SERVER} from './paths.js';


export const prepareTransaction = async ({id_product, jwt, userIP, userCountry, coupon, customPayout, customGW, redeemPin, customEmail, tenant }: {
    id_product: string | undefined,
    jwt: string | undefined,
    userIP: string,
    userCountry: string,
    coupon: string | undefined,
    customPayout: any,
    customGW: any,
    redeemPin: any,
    customEmail: any,
    tenant: any
}) => {
    try {

        const response = await axios.post(
            `${BACKEND_SERVER}/api/front/prepareTransaction`,
            { id_product: id_product, jwt, userIP, userCountry, coupon, customPayout, customGW, redeemPin, customEmail },
            {
                headers: {
                    'dg-user-country': userCountry,
                    'dg-user-ip': userIP,
                    'jwt': jwt,
                    'tenant': tenant
                }
            }
        );
        if (response.status === 200) {
            return response.data;
        } else {
            console.error('Transaction preparation failed:', response.status);
            return null;
        }
    } catch (error) {
        console.error('Error preparing transaction:', error);
        return null;
    }
};

export const createTransaction = async ({data, jwt, userIP, userCountry, tenant}: {
    data: any,
    jwt: any,
    userIP: any,
    userCountry: any,
    tenant: any
}) => {
    try {
        const response = await axios.post(`${BACKEND_SERVER}/api/front/createTransaction`, {
            data,
            jwt,
            userIP,
            userCountry,
        }, {
            headers: {
                'dg-user-country': userCountry,
                'dg-user-ip': userIP,
                'jwt': jwt,
                'tenant': tenant
            }
        });
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        console.error('Error creating transaction:', error);
        return null;
    }
};

export const listPaymentMethods = async ({data, jwt, userIP, userCountry}: {
    data: any,
    jwt: any,
    userIP: any,
    userCountry: any,
}) => {
    try {
        const response = await axios.post(`${BACKEND_SERVER}/api/front/paymentMethods`, {
            data,
            jwt,
            userIP,
            userCountry,
        }, {
            headers: {
                'dg-user-country': userCountry,
                'dg-user-ip': userIP,
                'jwt': jwt
            }
        });
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        console.error('Error creating transaction:', error);
        return null;
    }
};
